export const SOCKET_URL =
  process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';
